import React, { useEffect, useRef } from 'react';
import '@adyen/adyen-platform-experience-web/adyen-platform-experience-web.css';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AdyenPlatformExperience, CapitalOverview } from '@adyen/adyen-platform-experience-web';
import { getAdyenPlatformSessionCreate } from '@/ar/network/AccountsReceivable.network';
import { useSupplierStore } from '@/ar/stores/SupplierStore';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';

export const AdyenCapitalGrantsPage: React.FC = () => {
    useDocumentTitle('Capital Dashboard - Notch');
    const { enableAdyenCapitalGrants } = useFlags();
    // const [isLoading, setIsLoading] = useState<boolean>(false);
    const { supplierLoginData } = useSupplierStore();
    // const [error, setError] = useState<string | null>(null);
    const overviewContainerRef = useRef<HTMLDivElement>(null);
    // const [error, setError] = useState<string | null>(null);
    useEffect(() => {
        // if (!enableAdyenCapitalGrants) return;
        // console.log(`enableAdyenCapitalGrants: ${enableAdyenCapitalGrants}`);
        // console.log(useFlags());
        // setIsLoading(true);
        const init = async () => {
            const core = await AdyenPlatformExperience({
                onSessionCreate: (signal: AbortSignal) => getAdyenPlatformSessionCreate(supplierLoginData.supplier_id, signal),
            });

            const capitalOverview = new CapitalOverview({ core });
            if (overviewContainerRef.current) {
                capitalOverview.mount(overviewContainerRef.current);
            }
        };
        init().catch((error) => {
            console.error('Failed to initialize Adyen Capital Overview:', error);
            // setError('Could not load capital overview');
        });
    }, [enableAdyenCapitalGrants, supplierLoginData.supplier_id]);
    // init.catch((error) => {
    //     console.error('Failed to initialize Adyen Capital Overview:', error);
    //     setError('Could not load capital overview');
    // });
    return (
        <div>
            <h1>Capital Overview</h1>
            <div id="capital-overview-container" ref={overviewContainerRef} />
        </div>
    );
};
